import { bool, node } from 'prop-types';

import ActivityIndicator from '~/components/ActivityIndicator';

function LoadingWrapper({ loading, children }) {
  if (loading) {
    return <ActivityIndicator />;
  }
  return children;
}

LoadingWrapper.propTypes = {
  loading: bool.isRequired,
  children: node.isRequired,
};

export default LoadingWrapper;
